import { Group, GroupMember } from '@jupiterone/jupiter-web-toolkit';
import {
  Avatar,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import React, { Component } from 'react';
import { User, X } from 'react-feather';

interface Props {
  group: Group;
  classes: any;
  members: GroupMember[];
  onRemoveUser: (userId: string, groupId: string) => void;
  loading: boolean;
  finishedLoadingData?: boolean;
  loadMore?: (groupId: string) => Promise<void>;
}

export default class MembersTab extends Component<Props> {
  handleRemoveMember(member: GroupMember) {
    const { onRemoveUser, group } = this.props;
    return () => {
      onRemoveUser(member.id, group.id);
    };
  }
  handleLoadMore = () => {
    const { loadMore, group } = this.props;
    loadMore && loadMore(group.id);
  };

  render() {
    const { classes, loading, loadMore } = this.props;
    return (
      <div className={classes.tabContainer}>
        <Typography
          className={classes.tabHeader}
          variant="subtitle1"
          color="primary"
        >
          Members
        </Typography>
        <List>
          <Divider className={classes.divider} />
          {this.getMembers()}
          {loading && (
            <div className={classes.spinnerCenter}>
              <CircularProgress className={classes.circle} />
            </div>
          )}
          {loadMore && (
            <Button
              disabled={loading || this.props.finishedLoadingData}
              onClick={this.handleLoadMore}
              variant="contained"
            >
              Show More
            </Button>
          )}
        </List>
      </div>
    );
  }

  getMembers() {
    const { classes, members } = this.props;
    return members.map((m: GroupMember, index: number) => {
      return (
        <ListItem className={classes.listItem} key={index}>
          <ListItemAvatar>
            <Avatar className={classes.groupAvatar}>
              <User />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            disableTypography={false}
            classes={{
              primary: classes.primaryInvitation,
              secondary: classes.secondaryInvitation,
            }}
            primary={m.profile.name || m.id}
            secondary={m.profile.email || ''}
          />
          <ListItemSecondaryAction>
            <Tooltip enterDelay={500} placement="top" title="Remove">
              <IconButton
                className={clsx(
                  classes.listActionIcon,
                  classes.listActionIconNegative
                )}
                aria-label="Remove"
                onClick={this.handleRemoveMember(m)}
              >
                <X />
              </IconButton>
            </Tooltip>
          </ListItemSecondaryAction>
        </ListItem>
      );
    });
  }
}
